class Modal extends HTMLElement {
  ALLOWED_ORIGINS = ['https://cdn.shopify.com', 'https://acc-dreambaby-remix-giftlist.vercel.app', 'https://dreambaby-remix-giftlist.vercel.app'];
  LOCATION_STORAGE_KEY = 'preferred-location';

  constructor() {
    super();

    this.modal = this;
    this.modalTriggers = document.querySelectorAll(`[data-modal-trigger="${this.id}"]`);
    this.closeButtons = this.querySelectorAll('[data-modal-close]');
    this.isOpen = false;
    this.iframe = this.querySelector('.product-form__buy-iframe');
    this.locationId = sessionStorage.getItem(this.LOCATION_STORAGE_KEY);
    this.loadingSkeleton = this.querySelector('.modal__loading-skeleton');
    this.errorMessage = this.querySelector('.iframe-error');

    this.modalTriggers.forEach(trigger => {
      trigger.addEventListener('click', () => this.openModal());
    });

    this.closeButtons.forEach(button => {
      button.addEventListener('click', () => this.closeModal());
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && this.isOpen) {
        this.closeModal();
      }
    });

    window.addEventListener('message', (event) => this.handleIframeMessage(event));

    document.body.appendChild(this.modal);
  }

  openModal() {
    if(this.iframe) {
      this.iframe.src = this.iframe.src + `&defaultPickupStoreId=${this.locationId}`;
    }

    this.setAttribute('aria-hidden', 'false');
    this.isOpen = true;

    if (this.loadingSkeleton) {
      this.loadingSkeleton.classList.remove('hidden');
    }
    if (this.iframe) {
      this.iframe.classList.remove('loaded');
      this.iframe.style.display = '';
    }
    if (this.fallbackButton) {
      this.fallbackButton.classList.add('hidden');
    }
    if (this.errorMessage) {
      this.errorMessage.classList.add('hidden');
    }

    setTimeout(() => {
      // In some rare cases the iframe load does not trigger. In that case, we show a fallback.
      if (this.iframe.classList.contains('loaded')) {
        return
      }

      if (this.iframe) {
        this.iframe.style.display = 'none';
      }
      if (this.loadingSkeleton) {
        this.loadingSkeleton.classList.add('hidden');
      }
      if (this.errorMessage) {
        this.errorMessage.classList.remove('hidden');
      }
      if (this.fallbackButton) {
        this.fallbackButton.classList.remove('hidden');
      }
    }, 2000)
  }

  closeModal() {
    this.setAttribute('aria-hidden', 'true');
    this.isOpen = false;

    if (this.iframe) {
      this.iframe.src = this.iframe.src;
    }
  }

  handleIframeMessage(event) {
    if (!this.ALLOWED_ORIGINS.includes(event.origin)) {
      return;
    }

    switch (event.data.type) {
      case 'buyButtonReady':
        this.handleLoadedEvent();
        break;
    }
  }

  handleLoadedEvent() {
    if (this.loadingSkeleton) {
      this.loadingSkeleton.classList.add('hidden');
    }
    if (this.iframe) {
      this.iframe.classList.add('loaded');
      this.iframe.style.display = '';
    }
    if (this.errorMessage) {
      this.errorMessage.classList.add('hidden');
    }
    if (this.fallbackButton) {
      this.fallbackButton.classList.add('hidden');
    }
  }
}

customElements.define('modal-store-inventory', Modal);
